/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import image from '../../../../assets/images/image.svg';
import review from '../../../../assets/images/review.svg';
import service from '../../../../assets/images/service.svg';
import whatsapp from '../../../../assets/images/whatsapp.svg';
import Spinner from '../../../../assets/styles/spinner';
import Text from '../../../../assets/styles/Text';
import Loader from '../../../../components/Loader';
import { useToggleFollowModel } from '../../../../hooks/mutations/useModelMutations';
import { useModelVerification } from '../../../../hooks/queries/useMediaUploads';
import {
  useModelFindAboutsSection,
  useModelFollowerStatus,
  useModelTop,
} from '../../../../hooks/queries/useModels';
import { useStore } from '../../../../stores';
import calculateAge from '../../../../utils/calculateAge';
import formatPhone from '../../../../utils/formatPhone';
import messageClient from '../../../../utils/messageClient';
import * as styles from './styles';

export default function Banner() {
  // Estado local para toggle price (mantém)
  const [show, setShow] = useState(false);
  // Estado otimista para follow/unfollow
  const [optimisticFollowing, setOptimisticFollowing] = useState(null);

  const { id } = useParams();

  const user = useStore((state) => state.user);

  // Query for verification
  const { data: verification, isLoading: isLoadingVerification } =
    useModelVerification(id);

  // Query for ModelTop
  const { data: modelData, isLoading: isLoadingModelTop } = useModelTop(id);

  // Hook para follow status
  const { data: isFollowing, isLoading: isLoadingFollow } =
    useModelFollowerStatus(id, user?.type === 'client' ? user?.id : null);

  // Query abouts
  const { data: aboutData, isLoading: isLoadingAbouts } =
    useModelFindAboutsSection(id, 'TOP');

  // Mutation for follow/unfollow
  const followMutation = useToggleFollowModel();

  // Extrair dados dos props
  const profilePhoto = verification?.urls?.profilePhoto;
  const bannerPhoto = verification?.urls?.bannerPhoto;
  const followersCount = modelData?._count?.followers || 0;

  const loading = isLoadingFollow || isLoadingModelTop || isLoadingAbouts;

  // Resetar estado otimista quando a mutation terminar
  useEffect(() => {
    if (!followMutation.isPending && optimisticFollowing !== null) {
      // Aguarda um pouco para garantir que a query foi invalidada
      const timer = setTimeout(() => {
        setOptimisticFollowing(null);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [followMutation.isPending, optimisticFollowing]);

  async function handleFollower() {
    if (!user) {
      toast.error('Você precisa estar logado para seguir!');
      return;
    }

    if (user.type !== 'client') {
      toast.error('Apenas clientes podem seguir modelos!');
      return;
    }

    // Atualização otimista: inverte o estado atual
    const newFollowingState = !isFollowing;
    setOptimisticFollowing(newFollowingState);

    // Executa a mutation
    followMutation.mutate(id);
  }

  function isOnline(lastSeenAt) {
    if (!lastSeenAt) return false;

    const lastSeen = new Date(lastSeenAt).getTime();
    const now = Date.now();
    const diffInMinutes = (now - lastSeen) / 1000 / 60;

    return diffInMinutes <= 60;
  }

  function renderInfoTop(modelRender) {
    const {
      fantasyName,
      impactPhrase,
      phone,
      dateOfBirth,
      city,
      values,
      totalLikes,
      user: userModel,
    } = modelRender;

    const lastSeenAt = userModel?.lastSeenAt;

    return (
      <styles.GroupInfos>
        <styles.TopInfos>
          <styles.TopInfosTitle>
            <div className="text-status">
              <Text.H1 $bold>{fantasyName}</Text.H1>
              {isOnline(lastSeenAt) && (
                <styles.TopInfosStatus>
                  <div />
                  <Text.Span>Online</Text.Span>
                </styles.TopInfosStatus>
              )}
            </div>

            <styles.TopInfosGroup>
              <Text.P $bold>{followersCount} seguidores</Text.P>
              <Text.P $bold>{totalLikes} Curtidas</Text.P>
            </styles.TopInfosGroup>
          </styles.TopInfosTitle>

          <styles.ButtonInfos
            onClick={handleFollower}
            $follow={user?.type !== 'model'}
            $login={optimisticFollowing ?? isFollowing}
            disabled={followMutation.isPending}
          >
            {followMutation.isPending ? (
              <Spinner size={28} />
            ) : (
              <Text.P $bold>
                {optimisticFollowing ?? isFollowing ? 'Seguindo' : 'Seguir'}
              </Text.P>
            )}
          </styles.ButtonInfos>
        </styles.TopInfos>

        <styles.DescriptionInfos>
          <Text.Span>{impactPhrase}</Text.Span>
        </styles.DescriptionInfos>

        <styles.BottomInfos>
          <styles.GroupAboutInfos>
            <styles.InfosNav>
              <a href="#media">
                <img src={image} alt="image-icon" />
                <Text.Span $bold>Ver Midias</Text.Span>
              </a>

              <a href="#service">
                <img src={service} alt="service-icon" />
                <Text.Span $bold>Ver Serviços</Text.Span>
              </a>

              <a href="#review">
                <img src={review} alt="review-icon" />
                <Text.Span $bold>Ver Avaliações</Text.Span>
              </a>
            </styles.InfosNav>

            <styles.PrinceInfos $show={show}>
              <div>
                <Text.Span>A partir de:</Text.Span>
                <h1>
                  R$
                  {values?.[0]?.customRate} / {values?.[0]?.value.name}
                </h1>
              </div>
              <button
                type="button"
                onClick={() => setShow((prevState) => !prevState)}
              >
                Ver Valores
              </button>
            </styles.PrinceInfos>

            <styles.UlValues $show={show}>
              {values?.map((value) => (
                <li key={value?.id}>
                  <Text.Span>
                    R$ {value?.customRate} / {value?.value.name}
                  </Text.Span>
                </li>
              ))}
            </styles.UlValues>

            <styles.PhoneInfos>
              <a
                href={messageClient(phone, fantasyName)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={whatsapp} alt="whatsapp" />

                <div className="row">
                  <Text.Span>Converse Agora</Text.Span>
                  <h1>{formatPhone(phone)}</h1>
                </div>
              </a>
            </styles.PhoneInfos>
          </styles.GroupAboutInfos>

          <styles.GroupAboutInfos>
            <span>
              <Text.Span $bold>Cidade: </Text.Span>
              <Text.Span>{`${city?.name} - ${city?.stateAc}`}</Text.Span>
            </span>

            <span>
              <Text.Span $bold>Idade: </Text.Span>
              <Text.Span>{calculateAge(dateOfBirth)} anos</Text.Span>
            </span>

            {aboutData?.map((about) => {
              const aboutLocation = about.name === 'Possui Local';

              if (aboutLocation) {
                return (
                  <Text.Span $bold className="underline" key={about.name}>
                    {about.content === 'Sim' ? 'Com Local' : 'Sem Local'}
                  </Text.Span>
                );
              }

              return (
                <span key={about.name}>
                  <Text.Span $bold>{about.name}: </Text.Span>
                  <Text.Span>{about.content}</Text.Span>
                </span>
              );
            })}
          </styles.GroupAboutInfos>
        </styles.BottomInfos>
      </styles.GroupInfos>
    );
  }

  return (
    <styles.Container>
      <styles.WrapImg>
        <styles.BannerImg
          className="watermark"
          $banner={bannerPhoto || profilePhoto}
        >
          <Loader isLoading={isLoadingVerification} minimal />
        </styles.BannerImg>

        <styles.ProfileImg className="watermark" $profile={profilePhoto}>
          <Loader isLoading={isLoadingVerification} minimal />
        </styles.ProfileImg>
      </styles.WrapImg>

      {loading ? (
        <Loader isLoading={loading} minimal />
      ) : (
        renderInfoTop(modelData)
      )}
    </styles.Container>
  );
}
